import { defineMessages } from 'react-intl';

export const formFieldEditorMessages = defineMessages({
  back: { id: 'cyR7KhiuaU', defaultMessage: 'Back' },
  formTitleHintTitle: {
    id: 'tGhZRMK/SW',
    defaultMessage: 'Name your form',
    description: 'Title for the dismissible form editor title guidance tooltip',
  },
  formTitleHintDescription: {
    id: 'rmMMY2xWDt',
    defaultMessage:
      'Heidi uses the form title to match this form to the right consultation when auto-filling.',
    description: 'Description for the dismissible form editor title guidance tooltip',
  },
  formTitleAriaLabel: {
    id: '2hbJvSD7sc',
    defaultMessage: 'Form title',
    description: 'ARIA label for the inline editable form title input',
  },
  editFormTitle: {
    defaultMessage: 'Edit form title',
    id: 'D0USyX3lbp',
    description: 'ARIA label for the button that starts inline form title editing',
  },
  fieldRecognition: { id: '+ioUD8G01R', defaultMessage: 'Field recognition' },
  confirmFields: { id: '2VDoQa9rkH', defaultMessage: 'Confirm fields' },
  regenerateFields: { id: 'PcUC0dOjFr', defaultMessage: 'Regenerate fields' },
  regenerateFieldsPageLimit: {
    id: 'y4sncJSS1R',
    defaultMessage: 'Regeneration supports PDFs up to {maxPages} pages.',
  },
  regenerateFieldsModalTitle: {
    id: 'a72DVjjnjQ',
    defaultMessage: 'Regenerate fields with Heidi?',
    description: 'Title for the regenerate form fields confirmation modal',
  },
  regenerateFieldsModalDescription: {
    id: 'k4S3+9KJef',
    defaultMessage:
      'Heidi will re-scan this PDF and detect every field from scratch, giving each one a clear label it can match to information from your consultation.',
    description:
      'Intro explaining what regenerate does in the form field editor confirmation modal',
  },
  regenerateFieldsModalHelpfulWhen: {
    id: 'lrzgOrZLQ9',
    defaultMessage: 'This can help when:',
    description:
      'Heading above the list of situations where regenerating form fields is useful',
  },
  regenerateFieldsModalReasonMissing: {
    id: 'CkDZoPqBqK',
    defaultMessage: 'Fields are missing or in the wrong place',
    description: 'Reason to regenerate form fields: missing or misplaced detected fields',
  },
  regenerateFieldsModalReasonLabels: {
    id: '8AFFrgqOs0',
    defaultMessage:
      'Labels are vague or generic (like “Text1”), so the wrong details get filled in',
    description: 'Reason to regenerate form fields: vague labels hurt auto-fill matching',
  },
  regenerateFieldsModalReasonBuiltIn: {
    id: '5mBp0qn7N1',
    defaultMessage: 'The PDF’s built-in fillable fields don’t work well with auto-fill',
    description:
      'Reason to regenerate form fields: embedded AcroForm widgets fill poorly',
  },
  regenerateFieldsModalReplaceWarning: {
    id: 'H5BmFIBlsD',
    defaultMessage:
      'All current fields will be replaced, including any changes you’ve made.',
    description:
      'Warning that regenerating form fields discards existing detections and edits',
  },
  fieldsPanel: { id: 'iJMNSQGeC/', defaultMessage: 'Fields' },
  detectedFields: { id: 'mLzqRB2/Ig', defaultMessage: 'Detected fields' },
  processing: { id: '6OWS4p9SXV', defaultMessage: 'Processing...' },
  tryAgain: { id: 'FazwRldA7z', defaultMessage: 'Try again' },
  error: { id: 'pULLlp0duY', defaultMessage: 'Error: {message}' },
  getSupport: { id: 'Km7x3vvEGf', defaultMessage: 'Get support' },
  noFieldsDetected: { id: '3PJE7VQrc9', defaultMessage: 'No fields detected' },
  fieldsWillAppear: {
    id: 'bmowkP+3xN',
    defaultMessage: 'Fields will appear here after processing',
  },
  noFieldsAfterExtraction: {
    id: 'AS4wc0ns6y',
    defaultMessage: 'This PDF format is not supported or the file may be corrupted',
  },
  contactTeamToUpload: {
    id: 'gfJ8unA1AG',
    defaultMessage: 'Please try again or contact our team to upload your form manually.',
  },
  contactItTeam: {
    id: 'lGDDAdbAR4',
    defaultMessage: 'Please try again or contact your IT team.',
  },
  fieldLabel: {
    id: 'VzRF64p7XG',
    defaultMessage: 'Field label',
    description: 'Sidebar heading labeling the field label section of a detected field',
  },
  newFieldDefaultLabel: { id: 'JFFNduUlVh', defaultMessage: 'New field' },
  fieldLabelTooltip: {
    id: 'CWOC0tQcqj',
    defaultMessage:
      'Heidi uses this label to find the right information from your consultation to fill this field.',
  },
  fieldType: { id: '40nKoWw0pn', defaultMessage: 'Field type' },
  fontSize: { id: 'kc7szFdWzG', defaultMessage: 'Font size' },
  fontSizeAuto: { id: 'NXI/XLSYwc', defaultMessage: 'Auto' },
  fontSizeAutoHelpTooltip: {
    id: 'OeBdhdOkT/',
    defaultMessage:
      'Auto starts at the largest size that fits, then shrinks text to stay inside the field. Exact behavior depends on the PDF reader.',
  },
  fontSizeDefault: { id: 'lKv8exH0MR', defaultMessage: 'Default' },
  fillFromTranscript: { id: 'fUQqcLQ8hb', defaultMessage: 'Fill from transcript' },
  fillFromTranscriptHelp: {
    id: '4JwiTajbFV',
    defaultMessage: 'When off, this field is left blank for you to fill in manually.',
  },
  manualEntryOnly: {
    id: 'ArDYejGOmJ',
    defaultMessage: 'Manual entry only',
  },
  fieldPromptLabel: {
    defaultMessage: 'Instructions for Heidi',
    id: '5Ut5Kl7gI1',
    description:
      'Label for the optional per-field prompt that tells Heidi how to fill the field',
  },
  fieldPromptHelp: {
    defaultMessage:
      "Describe how Heidi should fill this field. Use [square brackets] to narrow what goes in it, (round brackets) for how to fill it, and double quotes for exact text to print. Put examples in single quotes, like 'DD/MM/YYYY', not a real answer.",
    id: '6eIk+T5qVj',
    description: 'Helper text under the per-field prompt input in the form editor',
  },
  fieldPromptPlaceholder: {
    defaultMessage: 'e.g. (Write as DD/MM/YYYY. Leave blank if not mentioned.)',
    id: 'm6n2fHwyJf',
    description: 'Placeholder for the per-field prompt input in the form editor',
  },
  promptCharacterCount: {
    defaultMessage: '{count} / {max}',
    id: '7MuvjpaIO3',
    description: 'Character count under a prompt input: characters used out of the limit',
  },
  formPromptButton: {
    defaultMessage: 'Form instructions',
    id: '+e0y6yGFkx',
    description: 'Header button that opens the form-wide prompt for Heidi',
  },
  formPromptButtonSet: {
    defaultMessage: 'Form instructions (set)',
    id: '5oE7OeU5GS',
    description:
      'Accessible label for the form instructions button when a form-wide prompt has been written',
  },
  formPromptTitle: {
    defaultMessage: 'Instructions for the whole form',
    id: 'MY4VftZgst',
    description: 'Title of the popover holding the form-wide prompt',
  },
  formPromptHelp: {
    defaultMessage:
      'Describe how Heidi should fill this form overall, for example the tone or which details to leave blank. A line like [Date of birth] (Write as DD/MM/YYYY.) applies to the field that holds that information. Put examples in single quotes, not a real answer.',
    id: 'Rwmfn1oCQ1',
    description: 'Helper text under the form-wide prompt input in the form editor',
  },
  formPromptPlaceholder: {
    defaultMessage:
      'e.g. (Write in the third person.)\n[Date of birth] (Write as DD/MM/YYYY.)',
    id: 'UvhTkOvX/B',
    description: 'Placeholder for the form-wide prompt input in the form editor',
  },
  formPromptSyntaxGuideTitle: {
    defaultMessage: 'Syntax guide',
    id: 'UHh+WuKs9S',
    description: 'Heading above the syntax guide in the form-wide prompt popover',
  },
  formPromptSyntaxPlaceholders: {
    defaultMessage: 'Placeholders',
    id: 'Gxu2gMyt3B',
    description: 'Form prompt syntax guide section for square-bracket placeholders',
  },
  formPromptSyntaxPlaceholdersDescription: {
    defaultMessage:
      'Say WHAT information a field holds inside square brackets. Heidi matches it to a field by meaning, so be specific.',
    id: 'OLQhyIu2MP',
    description: 'Form prompt syntax guide description for placeholders',
  },
  formPromptSyntaxPlaceholdersExample: {
    defaultMessage: 'e.g. [Date of injury] (Write as DD/MM/YYYY.)',
    id: 'QoZ79UQZGZ',
    description: 'Form prompt syntax guide example for placeholders',
  },
  formPromptSyntaxInstructions: {
    defaultMessage: 'Instructions',
    id: 'Zw8GtLcn/6',
    description: 'Form prompt syntax guide section for round-bracket instructions',
  },
  formPromptSyntaxInstructionsDescription: {
    defaultMessage:
      'Tell Heidi HOW to fill a field, and what to do when the information is not mentioned, inside round brackets',
    id: 'n8M/Z24dvv',
    description: 'Form prompt syntax guide description for instructions',
  },
  formPromptSyntaxInstructionsExample: {
    defaultMessage: 'e.g. (Only include if explicitly mentioned, else leave blank.)',
    id: 'sVBX0QTdKX',
    description: 'Form prompt syntax guide example for instructions',
  },
  formPromptSyntaxVerbatim: {
    defaultMessage: 'Verbatim',
    id: 'DKNIIoLsPQ',
    description: 'Form prompt syntax guide section for double-quoted verbatim text',
  },
  formPromptSyntaxVerbatimDescription: {
    defaultMessage:
      'Put exact text Heidi should print in double quotes. Put examples in single quotes so they are not printed.',
    id: 'PHTFb8jlLY',
    description: 'Form prompt syntax guide description for verbatim text',
  },
  formPromptSyntaxVerbatimExample: {
    defaultMessage: 'e.g. (Only include if mentioned, else print "Not discussed".)',
    id: 'getyAgK7KY',
    description: 'Form prompt syntax guide example for verbatim text',
  },
  addField: { id: 'eSYQTyLBll', defaultMessage: 'Add field' },
  removeField: { id: 'nX7n8hoz6p', defaultMessage: 'Remove field' },
  dragToReorderField: { id: '+DXHqO5bQ/', defaultMessage: 'Drag to reorder field' },
  undo: { id: 'JkS37H8PlA', defaultMessage: 'Undo' },
  redo: { id: '3XyF4dAMbz', defaultMessage: 'Redo' },
  fieldCopiedCount: {
    id: '0lqPN6s2pF',
    defaultMessage: 'Copied {count, plural, one {# field} other {# fields}}',
    description:
      'Success toast title after copying one or more fields in the form editor',
  },
  undoShortcutHint: { id: 'oa8p6PrkPf', defaultMessage: 'Undo (Cmd+Z / Ctrl+Z)' },
  redoShortcutHint: {
    id: 'b2Xobov2SZ',
    defaultMessage: 'Redo (Shift+Cmd+Z / Ctrl+Y)',
  },
  bulkFieldActions: { id: 'KoM+StRo0y', defaultMessage: 'Field actions' },
  bulkAllFieldsCount: {
    id: 'U78Q4UrrxH',
    defaultMessage: 'All {count, plural, one {# field} other {# fields}}',
  },
  bulkSelectedFieldsCount: {
    id: 'bOBT4+WBv1',
    defaultMessage: '{count, plural, one {# field} other {# fields}}',
    description: 'Label for bulk actions on a marquee-selected field group',
  },
  bulkSelectedFontSizeDialogDescription: {
    id: '92mdsxYwOO',
    defaultMessage:
      'This sets the font size of the selected fields to {size}. Other fields are unchanged.',
  },
  bulkSelectedFieldTypeDialogDescription: {
    id: 'T0z84tsSKf',
    defaultMessage:
      'This converts the selected fields to {type}. Other fields are unchanged.',
  },
  bulkSelectedFillFromTranscriptDialogDescription: {
    id: 'q0UhPKbnPd',
    defaultMessage:
      'This sets the selected fields to {mode}. Other fields are unchanged.',
  },
  bulkMixed: { id: 'fQZLRHLbaT', defaultMessage: 'Mixed' },
  bulkResetFontSize: {
    id: 'E42/xAgkyq',
    defaultMessage: 'Reset font size to default',
  },
  bulkDialogCancel: { id: '47FYwba+bI', defaultMessage: 'Cancel' },
  bulkFontSizeDialogTitle: {
    id: 'zSt0JT16VF',
    defaultMessage:
      'Change font size for {count, plural, one {# field} other {# fields}}?',
  },
  bulkFontSizeDialogDescription: {
    id: 'LRy99s6dg8',
    defaultMessage:
      'This sets the font size of every field on this form to {size}. Individual fields can still be adjusted afterwards.',
  },
  bulkFontSizeDialogConfirm: {
    id: 'rukB/BPjPk',
    defaultMessage: 'Change font size',
  },
  bulkFieldTypeDialogTitle: {
    id: 'VFCYnB9VVf',
    defaultMessage:
      'Change field type for {count, plural, one {# field} other {# fields}}?',
  },
  bulkFieldTypeDialogDescription: {
    id: 'sp8yX7ULeI',
    defaultMessage:
      'This converts every field on this form to {type}, including fields that were detected as other types.',
  },
  bulkFieldTypeDialogConfirm: {
    id: '3zIjPZ1G4r',
    defaultMessage: 'Change field type',
  },
  bulkFillFromTranscriptDialogTitle: {
    id: '7M8sRCPxgx',
    defaultMessage:
      'Change fill behavior for {count, plural, one {# field} other {# fields}}?',
  },
  bulkFillFromTranscriptDialogDescription: {
    id: 'vxLwsmcmBY',
    defaultMessage:
      'This sets every field on this form to {mode}. Individual fields can still be adjusted afterwards.',
  },
  bulkFillFromTranscriptDialogConfirm: {
    id: 'C0ilWbSlnO',
    defaultMessage: 'Change fill behavior',
  },
  applyFontSizeToAllFields: {
    id: '09H1x3RC9w',
    defaultMessage: 'Apply to all {count, plural, one {# field} other {# fields}}',
  },
  noValueDetected: { id: 'uE6ELSJgHl', defaultMessage: 'Not provided' },
  clearValue: { id: 'seboF3xhrh', defaultMessage: 'Clear value' },
  dropdownOptions: { id: 'Q7GggsH9OA', defaultMessage: 'Dropdown options' },
  fieldValue: { id: 'yxZLpwU6JV', defaultMessage: 'Field value' },
  enterValue: { id: 'uxcVP6BfBI', defaultMessage: 'Enter value...' },
  enterDate: { id: '0Re4TgbHU0', defaultMessage: 'Enter date...' },
  enterNumber: { id: 'YSvpmY1T0b', defaultMessage: 'Enter number...' },
  selectValue: { id: '8F1Ccg2T23', defaultMessage: 'Select a value' },
  checked: { id: 'a5msuh5ORp', defaultMessage: 'Yes' },
  unchecked: { id: 'oUWADlOjJt', defaultMessage: 'No' },
  fieldTypeText: { id: 'aA8bDwsPeJ', defaultMessage: 'Text' },
  fieldTypeCheckbox: { id: 'PRtqrCcfCF', defaultMessage: 'Checkbox' },
  fieldTypeRadio: { id: 'FdWeLUlsTt', defaultMessage: 'Radio Button' },
  fieldTypeSignature: { id: 'nQkv1Dw+lw', defaultMessage: 'Signature' },
  fieldTypeDate: { id: 'P7PLVjLe4f', defaultMessage: 'Date' },
  fieldTypeNumber: { id: 'kFkPWBneCz', defaultMessage: 'Number' },
  fieldTypeDropdown: { id: 'mART5Z/YX/', defaultMessage: 'Dropdown' },
  filter: { id: '9Obw6CDkje', defaultMessage: 'Filter' },
  clearFilters: { id: 'F4gyn3vRX6', defaultMessage: 'Clear filters' },
  selectPage: { id: 'rvz2nMM9x2', defaultMessage: 'Select page' },
  pdfPageLabel: { id: 'EF9EsXM2Gr', defaultMessage: 'PAGE {page}' },
  fieldsOnPageCount: {
    id: 's88ium+h8p',
    defaultMessage: '{count, plural, one {# result} other {# results}}',
  },
  previousField: { id: 'XG0xK9nKFq', defaultMessage: 'Previous field' },
  nextField: { id: 'OAE60Kc3Rc', defaultMessage: 'Next field' },
  close: { id: 'rbrahOGMC3', defaultMessage: 'Close' },
  searchFields: { id: 'uLNn2l21Pw', defaultMessage: 'Search fields' },
  clearSearch: { id: '4YJHutR26p', defaultMessage: 'Clear search' },
  other: { id: '/VnDMl81rh', defaultMessage: 'Other' },
  formEditorEditField: { id: 'LiNNTniyC6', defaultMessage: 'Edit field' },
  formEditorLabel: { id: '753yX5necH', defaultMessage: 'Label' },
  formEditorFieldLabelPlaceholder: {
    id: 'f3ujDPRl/e',
    defaultMessage: 'Field label',
    description: 'Placeholder text for the field label input in the field edit panel',
  },
  formEditorType: { id: '+U6ozcnv4r', defaultMessage: 'Type' },
  formEditorPosition: { id: 'U6qGuOVs+L', defaultMessage: 'Position' },
  formEditorPositionX: { id: 'MXPwVkq5Ri', defaultMessage: 'X' },
  formEditorPositionY: { id: 'SSHeHtsuzI', defaultMessage: 'Y' },
  formEditorWidth: { id: '5IP7APpSM7', defaultMessage: 'Width' },
  formEditorHeight: { id: 'teLZyZLRCK', defaultMessage: 'Height' },
  formEditorConfidence: { id: 'EoQTj0JKRR', defaultMessage: 'Confidence' },
  formEditorValue: { id: 'GufXy52FNI', defaultMessage: 'Value' },
  formEditorDeleteField: { id: 's6O1xS0WTA', defaultMessage: 'Delete field' },
  formEditorFieldTypeText: { id: 'lJvc4gO0yE', defaultMessage: 'Text Input' },
  formEditorFieldTypeButton: { id: 'KP63fg1AMS', defaultMessage: 'Button' },
  formEditorFieldTypeCheckbox: { id: 'PRtqrCcfCF', defaultMessage: 'Checkbox' },
  formEditorFieldTypeRadioButton: { id: 'FdWeLUlsTt', defaultMessage: 'Radio Button' },
  formEditorFieldTypeSignature: { id: 'nQkv1Dw+lw', defaultMessage: 'Signature' },
  formEditorFieldTypeComboBox: { id: 'mART5Z/YX/', defaultMessage: 'Dropdown' },
  formEditorFieldTypeListBox: { id: 'mART5Z/YX/', defaultMessage: 'Dropdown' },
  formEditorFieldTypeDate: { id: 'P7PLVjLe4f', defaultMessage: 'Date' },
  formEditorFieldTypeNumber: { id: 'kFkPWBneCz', defaultMessage: 'Number' },
  fieldInfoDisplay: { id: 'rc3z0CFWGH', defaultMessage: 'Field settings' },
  fieldInfoAuto: { id: 'NXI/XLSYwc', defaultMessage: 'Auto' },
  fieldInfoHidden: { id: 'ThUvIL4GaM', defaultMessage: 'Hidden' },
  formFillingUnableToLoadPdf: { id: 'byJMuA6s7C', defaultMessage: 'Unable to load PDF' },
  formFillingPageOf: { id: 'TxjoW4P0kC', defaultMessage: 'Page {current} of {total}' },
  formFillingLoadingPdf: { id: 'XniLoXhU+F', defaultMessage: 'Loading PDF...' },
  loadingUploadingDocument: {
    id: '0MqlZFUGl7',
    defaultMessage: 'Uploading document...',
  },
  loadingAnalyzingStructure: {
    id: 'K+Qjnj/Vg1',
    defaultMessage: 'Analyzing document structure...',
  },
  loadingDetectingFields: {
    id: 'to68kRCfcf',
    defaultMessage: 'Detecting form fields...',
  },
  loadingProcessingData: { id: '7GSBiKJ/3w', defaultMessage: 'Processing field data...' },
  loadingFinalizingResults: { id: 'X10JlW1uNG', defaultMessage: 'Finalizing results...' },
  unsavedChangesModalTitle: {
    id: '56t6ms0SCl',
    defaultMessage: 'Do you want to keep your latest changes?',
    description: 'Title when leaving the form field editor with unsaved changes',
  },
  unsavedChangesModalDescription: {
    id: 'itUe65hODT',
    defaultMessage:
      "You've made some updates to this form that haven't been saved. Save them now so nothing gets lost.",
    description: 'Body when leaving the form field editor with unsaved changes',
  },
  unsavedChangesModalDiscard: {
    id: '5DbfOMyk7x',
    defaultMessage: 'Discard changes',
    description: 'Destructive action to discard unsaved form field edits',
  },
  unsavedChangesModalSaveAndExit: {
    id: 'H+3zh6+yev',
    defaultMessage: 'Save & exit',
    description: 'Action to save form field changes and leave the editor',
  },
});
